import type { ReactNode } from 'react';

export type EmptyStateProps = { title: string; description: string; action?: ReactNode };

/** Says what to do next, rather than merely reporting that there is nothing. */
export function EmptyState({ title, description, action }: EmptyStateProps) {
  return (
    <div className="border-l-2 border-l-rule-strong py-(--space-6) pl-(--space-5)">
      <h2 className="text-[length:var(--text-lead)]">{title}</h2>
      <p className="mt-(--space-2) max-w-[42ch] text-ink-muted">{description}</p>
      {action !== undefined && <div className="mt-(--space-4)">{action}</div>}
    </div>
  );
}
